import axios from 'axios';
const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;

export const fetchContactById = (accessToken, idContact) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "contact_select",
            "action": "SELECT_BY_ID",
            "findOne": "true",
            "variables": JSON.stringify({
                'id_contact': idContact
            })
        })
    });
};

export const insertContact = (accessToken, data) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "contact_alter",
            "action": "INSERT",
            "variables": data
        })
    });
}

export const editContact = (accessToken, data) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "contact_alter",
            "action": "UPDATE",
            "variables": data
        })
    });
}

export const fetCompanies = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "client_select",
            "action": "SELECT_BY_CONTACT",
            "variables": '{}'
        })
    });
}